module.exports = __webpack_public_path__ + "c54f2a3ee42d2a58d82f1da293995d20.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Medium.ttf
// module id = 349
// module chunks = 0